module.exports = "/_next/static/images/calendar-duotone-44d0b5d2960b207690935f6b18f0c66c.svg";